module.exports = {
	"header": "Courriels et comptes liés",
	"addEmail": "Ajouter un courriel",
	"addSecondaryEmail": "Ajouter une deuxième adresse courriel",
	"enterEmail": "Entrez votre courriel",
	"email": "Courriel principal",
	"sendError": "Erreur en envoyant un courriel à: __emailAddress__",
	"organizationEmail": "Courriel",
	"emailRemoved": "Courriel retiré avec succès.",
	"emailsLinkedAccountsText": {
		"part1": "Ces identifiants donnent accès à votre compte.",
		"part2": "Vous pouvez vous connecter à l'aide d'un compte Google ou Facebook qui utilise l'un de ces courriels."
	},
	"emailUnconfirmed": "Non confirmé",
	"emailYesDelete": "Oui, supprimez cette adresse courriel",
	"organizationAccessInviteButton": "Avoir un accès au compte d'encanteur.",
	"organizationAccessInviteContent": "Vous avez été invité à avoir accès au compte d'encanteur de __sellerName__.",
	"organizationAccessNoAccount": "Cependant vous n'avez pas de compte __brand__. Une fois enregistré vous allez automatiquement avoir accès au compte d'encanteur __name__.",
	"confirmEmail": {
		"emailContent": "Nous avons besoin de confirmer la validité de votre adresse courriel pour votre compte __brand__.",
		"emailSent": "Courriel de confirmation envoyé à __emailAddress__.",
		"emailSubject": "Courriel de confirmation",
		"emailAfterButton": "Si vous n'avez pas demandé une confirmation, ignorez ce courriel.",
		"emailButton": "Je confirme qu'il s'agit de mon adresse courriel.",
		"linkNotValid": "Ce lien pour confirmer l'adresse courriel n'est pas valide.",
		"success": "Adresse courriel confirmée."
	},
	"forgotPw": {
		"emailContent": "Vous avez demandé une réinitialisation de mot de passe.",
		"emailAfterButton": "Si vous n'avez pas demandé de réinitialisation de mot de passe, ignorez ce courriel.",
		"emailSubject": "Réinitialisation de mot de passe"
	},
	"removeConfirmation": "Êtes-vous certain de vouloir enlever <email /> de vos adresses courriel?",
	"resendConfirmationEmail": "Envoyer le courriel de confirmation à nouveau",
	"cantAddSecondaryEmail": "Vous ne pouvez ajouter de courriel secondaire avant d'avoir confirmé votre adresse principale.",
	"successfullyAdded": "Vous avez ajouté une nouvelle adresse courriel avec succès.",
	"successfullyRemoved": "Vous avez enlevé l'adresse courriel avec succès.",
	"unconfirmedWarning": "Il y a déjà un courriel non-confirmé associé à ce compte, cet ajout va remplacer la demande existante.",
	"userList": {
		"emailAddedSubject": "Accès à __organization__",
		"emailAddedContent": "On vous a donné accès à __organization__. Vous pouvez vous connecter sur __brand__ pour miser maintenant ou vous créer un compte si vous n'en avez pas déjà un."
	}
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/email.json5
// module id = 1979
// module chunks = 6